<script setup lang="ts">
    const props = defineProps(['current', 'total']);
    const route = useRoute();
    const visiblePages = 5;
    const intTotal = Math.ceil(props.total);
    const pages = new Array(intTotal).fill(0).map((_, index) => index + 1);
    const siblingCount = visiblePages / 2;

    const start = computed(() => props.current - siblingCount - Math.max(props.current + siblingCount - intTotal, 0));
    const end = computed(() => props.current + siblingCount + Math.max(visiblePages - (props.current + siblingCount), 0));
    const sliced = computed(() => pages.slice(Math.max(start.value, 0), end.value));
    // TODO вобще общее кол-во кнопок должно быть всегда одинаковым включая добавочные первые и последние страницы и ellipsis
</script>

<template>
    <div aria-label="Страницы" class="uo-legacy-pagination pagination font-medium flex gap-1 justify-center items-center" v-if="intTotal > 1">
        <template v-if="!sliced.includes(1)">
            <nuxt-link :class="['hover:text-green-600 grid place-content-center w-8 aspect-square rounded-full']" :to="{ path: route.path, query: {  ...route.query, page: 1  } }">
                1
            </nuxt-link>
            <span class="opacity-40">...</span>
        </template>
        <template v-for="(page, index) in sliced">
            <nuxt-link :class="['hover:text-green-600 grid place-content-center w-8 aspect-square rounded-full', {'bg-green-600 text-white pointer-events-none': page == current}]" :aria-current="page == current ? 'page' : undefined" :to="{ path: route.path, query: {  ...route.query, page: page  } }">{{ page }}</nuxt-link>
        </template>
        <template v-if="!sliced.includes(intTotal)">
            <span class="opacity-40">...</span>
            <nuxt-link :class="['hover:text-green-600 grid place-content-center w-8 aspect-square rounded-full']" :to="{ path: route.path, query: {  ...route.query, page: intTotal  } }">
                {{ intTotal }}
            </nuxt-link>
        </template>
    </div>
</template>